import { createContext, use } from 'react'

import type { RealtimeContextValue, RealtimeState, StreamName, StreamState } from './types.ts'

export const RealtimeContext = createContext<RealtimeContextValue | null>(null)

function useRealtimeContext(): RealtimeContextValue {
  const value = use(RealtimeContext)
  if (!value) throw new Error('RealtimeProvider 바깥에서 useRealtime 을 썼다')
  return value
}

export function useRealtime(): RealtimeState {
  return useRealtimeContext().state
}

export function useStreamState(name: StreamName): StreamState {
  return useRealtime()[name]
}

/** 스트림이 끊겼거나 stale 이면 상태변경 버튼을 전부 비활성한다. */
export function useControlDisabled(): boolean {
  return useRealtime().controlDisabled
}

/** 붙었던 채널이 끊겼다 — 「연결 끊김」 띠의 축. 첫 연결 중에는 거짓이다(`RealtimeState.outage`) */
export function useStreamOutage(): boolean {
  return useRealtime().outage
}

/**
 * 원시 이벤트 구독. 🔴 **화면이 쓰는 것이 아니다** — `@ctcells/api` 의 스트림 브리지가
 * 이걸로 캐시를 무효화한다. realtime 은 쿼리 키를 모른다.
 *
 * ```ts
 * const subscribe = useStreamSubscribe()
 * useEffect(() => subscribe('events', (raw) => { ... }), [subscribe])
 * ```
 */
export function useStreamSubscribe() {
  return useRealtimeContext().subscribe
}
